<template>
  <v-dialog v-model="dialog" width="650" persistent>
    <v-card flat style="height: 100% !important;">
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title>Pilih Pengawas</v-toolbar-title>
        <v-spacer />
        <v-btn text icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-container>
        <base-table-header @search="onSearch" @reload="onReload" :options="{ header: 'py-0' }">
          <template v-slot:subtitle>
            <div class="my-auto body-2 black--text"> {{ total }} Data Pengawas </div>
          </template>
        </base-table-header>
        <div style="max-height: 350px; overflow-y: auto">
          <base-list-table :hideHeader="true" :loading="loading" :item="data" :total="total" :usePaging="false">
            <template slot-scope="{ item, index }">
              <td v-if="item.key !== 'lainnya'">
                <v-list-item dense class="px-0">
                  <v-list-item-avatar color="secondary">
                    <v-icon dark>mdi-account</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <div class="blue--text">{{ item.nama }}</div>
                    <div><strong>SIMPKB ID / Nomor UKG: </strong> {{ item.ptk_id }}</div>
                    <div>Alamat Surel: {{ item.alt_email }}</div>
                  </v-list-item-content>
                  <v-list-item-action-text>
                    <v-radio-group v-model="selected">
                      <v-radio :value="index" />
                    </v-radio-group>
                  </v-list-item-action-text>
                </v-list-item>
              </td>
              <td class="px-0" v-else>
                <v-list-item class="px-0">
                  <v-list-item-content>
                    <v-alert text color="blue">
                      <v-row no-gutters>
                        <v-col cols="11">
                          <div class="blue--text">Data Pengawas Tidak Tersedia?</div>
                          <p class="body-2 black--text mb-0">
                            Jika Pengawas yang dimaksud tidak ditemukan, isikan data pengawas tersebut. Data isian
                            tersebut hanya sebagai informasi tambahan saja, bukan sebagai pengawas yang telah ditentukan
                            sebagai peserta PKP 2
                          </p>
                        </v-col>
                        <v-col cols="1" class="text-right">
                          <v-radio-group v-model="selected" class="text-right">
                            <v-radio value="lainnya" class="pa-0 ma-0" />
                          </v-radio-group>
                        </v-col>
                      </v-row>
                    </v-alert>
                  </v-list-item-content>
                </v-list-item>
              </td>
            </template>
          </base-list-table>
        </div>
        <base-table-footer :pageTotal="pageTotal" @changePage="onChangePage" />
        <v-divider class="mb-3 mt-7" />
        <div class="text-right">
          <v-btn color="success" :disabled="selected === null" depressed @click="onSelect">Pilih Peserta</v-btn>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import list from '@mixins/list';
import { mapActions } from 'vuex';

export default {
  mixins: [list],
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      selected: null,
      total: 0,
    };
  },
  methods: {
    ...mapActions('dppPengawas', ['candidate']),

    fetchData() {
      const params = Object.assign(this.params, this.$isObject(this.filters) ? this.filters : {});
      this.candidate({ params }).then(({ data, meta }) => {
        this.data = data || [];
        this.total = meta?.total || 0;
        this.pageTotal = meta?.last_page || 1;
        this.params.limit = meta?.per_page || this.params.limit;

        if (params.page === this.pageTotal || this.total === 0) {
          this.data.push({ key: 'lainnya' });
          this.total = 1;
        }
      });
    },

    open() {
      this.selected = null;
      this.dialog = true;
      this.data = [];
      this.fetchData();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    onSelect() {
      let selected = { ptk_id: '' };
      if (this.selected !== 'lainnya') {
        selected = this.data[this.selected] || {};
      }

      this.resolve(selected);
      this.dialog = false;
    },
  },
};
</script>
<style scoped>
.v-radio {
  display: block !important;
}
</style>
